import { LogoutOutlined } from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import type { MenuProps } from 'antd';
import { Spin } from 'antd';
import { createStyles } from 'antd-style';
import React from 'react';
import { useLogtoContext } from '@/components/LogtoWrapper';
import HeaderDropdown from '../HeaderDropdown';

export type GlobalHeaderRightProps = {
  onLogout?: () => void;
};

const useUserInfo = () => {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = (initialState as any) || {};

  const cachedUser = React.useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('current_user') || 'null');
    } catch {
      return null;
    }
  }, []);

  return currentUser || cachedUser || { name: 'Admin', avatar: '/avatar.svg' };
};

export const AvatarName = () => {
  const user = useUserInfo();
  return <span className="anticon">{user.name}</span>;
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({
  onLogout,
}) => {
  const { styles } = useStyles();
  const { initialState } = useModel('@@initialState');
  const user = useUserInfo();

  const logtoContext = useLogtoContext();

  /**
   * 退出登录
   */
  const loginOut = async () => {
    if (onLogout) {
      onLogout();
      return;
    }

    try {
      await logtoContext.signOut();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const onMenuClick: MenuProps['onClick'] = (event) => {
    const { key } = event;
    if (key === 'logout') {
      loginOut();
    }
  };

  const loading = (
    <span className={styles.action}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const menuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
    },
  ];

  return (
    <HeaderDropdown
      menu={{
        selectedKeys: [],
        onClick: onMenuClick,
        items: menuItems,
      }}
    >
      <span className={styles.action}>
        <img
          alt="avatar"
          src={user.avatar || '/avatar.svg'}
          style={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            marginRight: 8,
          }}
        />
        <span>{user.name}</span>
      </span>
    </HeaderDropdown>
  );
};
